import * as React from 'react';

const svgTopNavbarSearchIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M6.41667 11.0833C8.99399 11.0833 11.0833 8.99399 11.0833 6.41667C11.0833 3.83934 8.99399 1.75 6.41667 1.75C3.83934 1.75 1.75 3.83934 1.75 6.41667C1.75 8.99399 3.83934 11.0833 6.41667 11.0833Z"
          stroke="#6B6B6B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2504 12.2499L9.71289 9.7124"
          stroke="#6B6B6B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default svgTopNavbarSearchIcon;
